import { render, staticRenderFns } from "./da1.vue?vue&type=template&id=843447b8&"
import script from "./da1.vue?vue&type=script&lang=js&"
export * from "./da1.vue?vue&type=script&lang=js&"
import style0 from "./da1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "da1.vue"
export default component.exports